import { ServiceBase, Result, PagedResult, convertStringsToDates } from "./ServiceBase";
import { ELP } from "../models/index";

export class ELPService extends ServiceBase {

    public static async list(): Promise<Result<ELP[]>> {

        var result = await this.requestJson<ELP[]>({
            url: `api/ELP/list`,          
            method: "GET"
        });

        return result;
    }   
}